import React, { useEffect, useMemo, useState } from "react";
import "moment/locale/zh-cn";
import useDeviceType from "Utils/useDeviceType";
import { toNumber } from "../homework/utils/filter";
import useCurrentDate from "Utils/useCurrentDate";
import useRequest from "Utils/useRequest";
import Config from "config";
import useStorage from "Utils/useStorage";
import {
    getCourseList,
    getExamTime,
    getSysMessage,
    loginLog,
    setSingleRead,
    SysMessage
} from "API";
import moment from "moment";
import _ from "underscore";
import MainPC from "./components/MainPC";
import MainMobile from "./components/MainMobile";
import useModalHandler from "Utils/useModalHandler";
import NoticeModal from "./components/NoticeModal";
import style from "./main.module.scss";
import { batchNoAtom } from "./store";
import { useAtomValue } from "jotai";
import { getSessionList, ReceiverType } from "API/chat";
import { Icon } from "antd";
import { useHistory, Link } from "react-router-dom";

export default function PageMain() {
    const modal = useModalHandler();
    const { isPC, isWebview } = useDeviceType();
    const history = useHistory();

    const batchNo = useAtomValue(batchNoAtom);
    const [batch] = useStorage("batch", batchNo || Config.DefaultBatch);
    const {
        theWeek,
        startDate: startDateOfBatch,
        synced,
        time,
        endDate: endDateOfBatch
    } = useCurrentDate();

    const [week, setWeek] = useState(toNumber(theWeek));

    const [CourseData, { loading }] = useRequest(
        () => getCourseList(week),
        {},
        [batch, week]
    );

    const [examTime] = useRequest(getExamTime);
    const [sysMessage] = useRequest(getSysMessage);

    const [notice, setNotice] = useState<SysMessage>();

    useEffect(() => {
        loginLog(localStorage.getItem("user") || "未登录").catch(err => {});
    }, []);

    useEffect(() => {
        if (!time.isBetween(startDateOfBatch, endDateOfBatch))
            return setWeek(1);
        setWeek(toNumber(theWeek));
    }, [synced, theWeek]);

    // 计算所选择周的起止时间
    const [startDate, endDate] = useMemo(() => {
        const startDate = moment(startDateOfBatch)
            .startOf("week")
            .add(week - 1, "weeks")
            .format("YYYYMMDD");
        const endDate = moment(startDate).add(6, "d").format("YYYYMMDD");
        return [startDate, endDate];
    }, [week, startDateOfBatch]);

    const data = useMemo(() => {
        if (!CourseData || !synced) return [];

        const groupData =
            CourseData.find(item => item.week === week.toString())?.dayList ||
            [];
        const newData = [];

        for (let i = 0; i < 7; i++) {
            const date = moment(startDate).add(i, "d").format("YYYYMMDD");
            const courses = _.find(groupData, { date })?.courseList || [];
            newData.push({ day: i.toString(), courses, date });
        }

        return newData;
    }, [CourseData, week, synced, startDate]);

    const handleShowNotice = (id: string) => {
        modal.open();
        if (!sysMessage) return;
        const data = sysMessage?.find(item => item.id === id);
        setNotice(data);
        setSingleRead(id);
    };

    //会话列表
    const [contacts] = useRequest(() => getSessionList());
    const studentNo = localStorage.getItem("user");

    const key = studentNo + "-" + ReceiverType.Student;
    const unreadListByInterface = contacts?.some(item =>
        item.notReadNoTypeList?.includes(key)
    );

    return (
        <div>
            <div className={style.notice}>
                {examTime && examTime.length !== 0 && (
                    <Link className={style.noticeItem} to={`/exam/time`}>
                        查看考试安排
                    </Link>
                )}

                {sysMessage?.length !== 0 &&
                    sysMessage?.map(item => (
                        <div
                            className={style.noticeItem}
                            onClick={() => handleShowNotice(item.id)}
                            key={item.id}>
                            {item.title}
                        </div>
                    ))}

                {unreadListByInterface && (
                    <div
                        className={style.chat}
                        onClick={() => history.push("/chat")}>
                        <Icon type="mail" />
                        您有未读消息，点击可前往聊天查看
                    </div>
                )}
            </div>

            {isPC && (
                <MainPC
                    week={week}
                    currentWeek={toNumber(theWeek)}
                    onWeekChange={setWeek}
                    data={data}
                    loading={loading || !synced}
                    startDate={startDate}
                    endDate={endDate}
                />
            )}

            {!isPC && (
                <MainMobile
                    week={week}
                    currentWeek={toNumber(theWeek)}
                    onWeekChange={setWeek}
                    data={data}
                    loading={loading || !synced}
                    startDate={startDate}
                    endDate={endDate}
                />
            )}

            {notice !== undefined && (
                <NoticeModal
                    visible={modal.visible}
                    onCancel={modal.close}
                    data={notice}
                />
            )}
        </div>
    );
}
